import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BusApiService } from 'src/app/services/api/bus-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-change-jiegehao-modal',
  templateUrl: './change-jiegehao-modal.component.html',
  styleUrls: ['./change-jiegehao-modal.component.scss'],
})
export class ChangeJiegehaoModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ChangeJiegehaoModalComponent>,
    private api: BusApiService,
    private router: Router,
    private message: MessageService
  ) {}

  loading = false;

  async changeJiegehao() {
    try {
      this.loading = true;
      const r = await this.api.changeJiegehao(
        this.data.id,
        this.data.bus.platform_id,
        this.data.bus_id,
        this.data.bus.bus_account_id,
        this.data.remaining_days
      );
      if (r.status === 0) {
        this.message.open('提交成功');
        this.dialogRef.close();
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/user/profile/seats']);
          });
      } else {
        this.message.warn('未知错误');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  goto() {
    window.open('https://jiegehao.cn/');
  }
}
